var exports = {
  "H": "Flash__In94r4",
  "a": "Box__L9Z59B",
};

module.exports = exports;
